import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { FaTrash } from "react-icons/fa";
import { typeTitle } from "../../../../formatters/courseAuthor";
import { courseComponentViews } from "../../../../utils/courseViews";
import { PreferredLocale } from "../../../../utils/locales";
import { CourseInstructionType, ICourseComponent } from "../../../course-author/types";
import ClickableElement from "../../../utils/ClickableElement";
import ActionConfirmationButton from "../ActionConfirmation";

export const ComponentLinkDiv = styled.div(
  props => `
  background: ${props["data-selected"] ? props.theme.colors.black : "inherit"};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &:hover {
    background: ${props.theme.colors.black};
  }

  a {
    width: 100%;
  }
`
);

export const ClickableComponentLink = styled(ClickableElement)`
  padding: 0;
  text-align: left;
`;

interface IComponentLinkProps {
  component: ICourseComponent;
  currentLocale: PreferredLocale;
  deleteFn: () => void;
  onClick: React.EventHandler<React.MouseEvent>;
  selected: boolean;
  to: string;
  type?: CourseInstructionType;
}

const ComponentLink: React.SFC<IComponentLinkProps> = ({
  component,
  currentLocale,
  deleteFn,
  onClick,
  selected,
  to,
  type,
}) => (
  <ComponentLinkDiv data-selected={selected}>
    <Link to={to} onClick={onClick}>
      <ClickableComponentLink>
        {courseComponentViews.localizedTitle(currentLocale)(component) || typeTitle(type)}
      </ClickableComponentLink>
    </Link>
    <ActionConfirmationButton action={"Delete"} actionFn={deleteFn} ActionIcon={FaTrash} />
  </ComponentLinkDiv>
);

export default ComponentLink;
